/** Shared placeholder used when an admin image is missing or fails to load. */
export const IMAGE_PLACEHOLDER = '/images/placeholder.svg'

const FALLBACK_ATTR = 'data-mypoda-img-fallback'

function isPlaceholderSrc(src) {
  if (!src) return true
  const value = String(src)
  return value.includes('/images/placeholder.svg') || value.endsWith('placeholder.svg')
}

/**
 * Capture-phase handler so broken <img> (including nested b-avatar images)
 * swap to the placeholder once without looping.
 */
export function installImageFallback() {
  if (typeof document === 'undefined') return
  if (typeof window !== 'undefined' && window.__mypodaImageFallbackInstalled) return
  if (typeof window !== 'undefined') {
    window.__mypodaImageFallbackInstalled = true
  }

  document.addEventListener(
    'error',
    event => {
      const el = event.target
      if (!el || el.tagName !== 'IMG') return
      if (el.getAttribute(FALLBACK_ATTR) === '1') return

      const src = el.currentSrc || el.getAttribute('src') || ''
      // Already on placeholder (or placeholder itself failed) — stop retrying.
      if (src && isPlaceholderSrc(src)) {
        el.setAttribute(FALLBACK_ATTR, '1')
        return
      }

      el.setAttribute(FALLBACK_ATTR, '1')
      el.removeAttribute('srcset')
      el.src = IMAGE_PLACEHOLDER
    },
    true,
  )
}

/** Return placeholder for empty / null-ish media paths. */
export function mediaUrlOrPlaceholder(path) {
  if (path === null || path === undefined) return IMAGE_PLACEHOLDER
  const trimmed = String(path).trim()
  if (!trimmed || ['null', 'undefined', 'none', 'n/a', '-'].includes(trimmed.toLowerCase())) {
    return IMAGE_PLACEHOLDER
  }
  return trimmed
}
